<template>
<div id="container">
<!--div class="preloader"></div-->
<!-- /메인비주얼 -->
<section class="slider_area slider_area_tow row m0 winH">
    <div class="slider_inner">
        <div data-thumb="/static/images/main/img_main_01.jpg" data-src="/static/images/main/img_main_01.jpg">
            <div class="camera_caption">
               <div class="container">
                    <p class=" wow fadeInUp animated" data-wow-delay="0.8s"><span>D</span>ata <br> <span>A</span>nalysis <br> <span>M</span>arketplace for <br> <span>D</span>ata <br> <span>A</span>lliance</p>
                    <h5 class=" wow fadeInUp animated">데이터로 가치를 담다. 혁신을 담다. 비전을 담다.</h5>
                    <h3 class=" wow fadeInUp animated" data-wow-delay="0.5s">미래 데이터 경제의 방향을 제시합니다.</h3>
               </div>
            </div>
        </div>
        <div data-thumb="/static/images/main/img_main_02.jpg" data-src="/static/images/main/img_main_02.jpg">
            <div class="camera_caption">
               <div class="container">
                    <p class=" wow fadeInUp animated" data-wow-delay="0.8s"><span>D</span>ata <br> <span>A</span>nalysis <br> <span>M</span>arketplace for <br> <span>D</span>ata <br> <span>A</span>lliance</p>
                    <h5 class=" wow fadeInUp animated">데이터로 가치를 담다. 혁신을 담다. 비전을 담다.</h5>
                    <h3 class=" wow fadeInUp animated" data-wow-delay="0.5s">미래 데이터 경제의 신대륙을 개척합니다.</h3>
               </div>
            </div>
        </div>
    </div>
</section>
<!-- //메인비주얼 -->
   <div class="mainContent">

     <!-- /공지사항 -->
     <div class="mcSec mcSec1">
       <div class="inner">
         <div class="main_notice">
           <center>DAMDA NOTICE</center>
           <h2 class="mainTit2 aniBox type_bot gogo">담다 공지사항</h2>
           <ul class="main_notice_list clearfix">
             <li v-for="listItem in gridData" :key="listItem.keyid">
               <a href="javascript:" @click="goDetail(listItem.keyid)">
                 <div class="img_box aniBox type_cv delay01 gogo">
                  <template v-if="listItem.thumb">
                    <span class="bg_img" :style="{ 'background-image': 'url(' + listItem.thumb + ')' }"></span>
                  </template>
                  <template v-else>
                    <span class="bg_img"></span>
                  </template>
                 </div>
                 <div class="txt_box aniBox type_bot delay01 gogo">
                   <strong class="ellipsis" v-text="listItem.title" :class="{ 'bell' : isImportant(listItem.importantYn), 'new' : isNewM(listItem.regDate) }"></strong>
                   <span v-text="dateFmt(listItem.regDate)"></span>
                   <p class="ellipsis" v-html="listItem.cvtContents?listItem.cvtContents:'&nbsp;'"></p>
                 </div>
               </a>
             </li>
           </ul>
           <div class="btn_area taC aniBox type_bot gogo">
             <router-link to="/support/notice" class="btn_vm">더보기</router-link>
           </div>
         </div>
       </div>
     </div>
     <!-- //공지사항 -->

     <!-- /기업협의회 -->
     <div class="mcSec mcSec2">
       <div class="mainBot aniBox type_fade gogo">
         <div class="txt_box aniBox gogo">
           <p class="txt_yellow">IoT, 빅데이터 등 4차 산업혁명 핵심기술을 활용하여 가전 · 전자산업의 혁신적인 비즈니스 생태계를 육성하기 위해 상호 유기적인 협조체계 구축</p>
           <h2><span>D</span>ata <span>A</span>nalysis <span>M</span>arketplace for <span>D</span>ata <span>A</span>lliance</h2>
           <h3>빅데이터 기업협의회</h3>
           <dl>
             <dt>IoT제품 개발 · 연동</dt>
             <dd>IoT</dd>
           </dl>
           <dl>
             <dt>빅데이터 분석환경</dt>
             <dd>Analytics</dd>
           </dl>
           <dl>
             <dt>IoT제품 모바일앱</dt>
             <dd>Mobile</dd>
           </dl>
           <dl>
             <dt>해외데이터 규제대응컨설팅</dt>
             <dd>Consulting Service</dd>
           </dl>
           <dl>
             <dt>비지니스 개발</dt>
             <dd>Training Service</dd>
           </dl>
           <p class="txt_light">담다는 <strong>기업의 IoT제품 개발부터 데이터 비즈니스까지 지원하는 플랫폼</strong> 입니다.<br>빅데이터 기업협의회에 가입하시고 DAMDA에서 제공하는 지원을 받으세요.</p>
           <router-link to="/partner#apply" class="btn_vm ty_white">기업협의회 가입신청</router-link>
         </div>
       </div>
     </div>
     <!-- //기업협의회 -->
   </div>
 </div> <!-- container -->
</template>

<script>
import axios from 'axios'
import moment from 'moment'

export default {
  name: 'HomeMain',
  data () {
    return {
      gridData: [],
      pageInfo: [],
      pageNo: 1,
      countPerPage: 4
    }
  },
  components: {
  },
  created () {
  },
  mounted () {
    let script1 = document.createElement('script')
    script1.setAttribute('src', '/static/vendors/animate/wow.min.js')
    let script2 = document.createElement('script')
    script2.setAttribute('src', '/static/vendors/camera-slider/jquery.easing.1.3.js')
    let script3 = document.createElement('script')
    script3.setAttribute('src', '/static/vendors/camera-slider/camera.min.js')
    let script4 = document.createElement('script')
    script4.setAttribute('src', '/static/js/theme.js')
    let script5 = document.createElement('script')
    script5.setAttribute('src', '/static/js/ScrollTrigger.min.js')
    document.body.appendChild(script1)
    document.body.appendChild(script2)
    document.body.appendChild(script3)
    document.body.appendChild(script4)
    document.body.appendChild(script5)

    this.loadData(1, true)

    window.counter = function () {
      var span = this.querySelector('span')
      var current = parseInt(span.textContent)
      span.textContent = current + 1
    }
    /*
    document.addEventListener('DOMContentLoaded', function () {
      var trigger = new ScrollTrigger({
        addHeight: true
      })
    })
    */
  },
  methods: {
    dateFmt (dt) {
      return moment(dt).format('YYYY-MM-DD')
    },
    isImportant: function (val) {
      if (val === 'Y') return true
      else return false
    },
    isNewM: function (dt) {
      var now = moment()
      var regdt = moment(dt)
      return now.diff(regdt, 'days') < 3
    },
    loadData (no, re) {
      var _this = this
      _this.pageNo = no
      var params = {
        pageNo: no || 1,
        countPerPage: _this.countPerPage
      }
      axios.get('/web/api/board/NOT', { withCredentials: true, params: params })
        .then(response => {
          if (re) {
            if (response.data.result) {
              _this.gridData = response.data.result
            } else {
              _this.gridData = []
            }
          } else {
            if (response.data.result) {
              _this.gridData = _this.gridData.concat(response.data.result)
            } else {
            }
          }
        })
        .catch(e => {
          console.log('error : ', e)
        })
    },
    goDetail (no) {
      this.$router.push('/support/notice/' + no)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/HomeMain.vue